<template>
    <div class="intro-page-container" v-if="slide === 1">
        <div class="intro-page text-center">
            <h6 class="mb-2">Meet A Side præsenterer</h6>
            <h1 class="mb-4 text-center">Roskildemodellen</h1>
            <p class="mb-4 text-left ">Har du bekymringer for et barns trivsel og udvikling, skal du bruge Roskildemodellen. Linealen er et vigtigt element i Roskildemodellen. Dette spil vil introducere dig og din arbejdsplads til Linealen. Start med at se den lille film nedenfor.</p>
            <!-- <media source="https://www.youtube.com/watch?v=y5P08lh-VOE" /> -->
            <video class="video-container" controls>
                <source src="@/_assets/Roskildemodellen.mp4" type="video/mp4">
            </video>
            <app-button
                    class="py-4"
                    buttonStyle="secondary"
                    v-on:onClick="slide = 2"
            >
                {{$t('misc.next')}}
            </app-button>
        </div>
    </div>
    <div class="intro-page-container" v-else-if="slide === 2">
        <div class="intro-page text-center" >
            <h1 class="mb-4 text-center">Sådan Spiller I</h1>
            <p class="text-left">
                Spillet tager udgangspunkt i Roskildemodellen og Linealen. I spillet skal I prøve kræfter med en case, der omhandler et barn på enten 3, 10 eller 14 år. I følger barnet, det pædagogiske personale, lærere, forældrene og andre, der har en relation til barnet. Spillet varer 1,5 time, og hver case indeholder seks kapitler. I møder løbende en række dilemmaer, som I skal tage stilling til, og I skal flere gange undervejs åbne og bruge Linealen.
                <br><br>
                I skal først vælge en case og derefter logge ind. 
                <br><br>
                Klik videre, og vælg en case.
            </p>
            <app-button
                    class="py-4"
                    buttonStyle="secondary"
                    v-on:onClick="finish"
            >
                {{$t('misc.next')}}
            </app-button>
        </div>
    </div>
</template>

<script>
    import AppButton from '@/components/app-button';
    import Media from '@/components/media';
    import { getTeacherUrl } from '@/utils/UrlUtil';
    import * as MutationTypes from '@/store/mutation-types';

    export default {
        components: {
            AppButton,
            Media
        },
        data() {
            return {
                slide: 1,
            }
        },
        mounted() {
            this.$store.commit(MutationTypes.SET_BREADCRUMB_TO, '/');
        },
        methods: {
            finish() {
                this.$router.push(getTeacherUrl('select-theme'));
            }
        }
    }
</script>

<style lang="less" scoped>
    .intro-page {
        width: 90%;
        max-width: 1000px;
        margin-left: auto;
        margin-right: auto;
    }

    .video-container {
        width: 90%;
        max-width: 650px;
        margin-left: auto;
        margin-right: auto;
        display: block;
        outline: none;
    }
</style>